import { ItemList } from 'orm'
import { map, get } from 'lodash'
import { getBeneficiaryVettingNotificationModelId } from './admin_active_notification_model'

class NotificationList extends ItemList {
    getEntityKey() {
        return "admin/notification"
    }

    getAsOptions() {
        const items = this.getVisibleObjects()
        return map(items, function(item) {
          return { label: item.name, value: item.id }
        }
      )
    }
}

export const adminNotificationList = new NotificationList("admin_notification__default")

export async function createBeneficiaryVettingNotification(
  dispatch,
  vettingData,
  notificationType,
  { fallbackVettingRecord, user, activeNotificationModels }
) {
  try {
    const record = vettingData || fallbackVettingRecord
    const vetName = get(record, 'company_legal_name', 'Vetting')
    const vetId = get(record, 'ref', get(record, 'id'))
    const notificationConfig = {
      created: { verb: 'created', severity: 'info' },
      approved: { verb: 'approved', severity: 'success' },
      declined: { verb: 'declined', severity: 'warning' }
    }
    const { verb, severity } = notificationConfig[notificationType] || notificationConfig.created
    const userId = get(user, 'id') || get(user, 'ref')
    const notificationModelId = await getBeneficiaryVettingNotificationModelId(
      dispatch,
      activeNotificationModels
    )

    if (!userId || !notificationModelId) {
      return
    }

    const message = `Beneficiary vetting "${vetName}" has been ${verb}.`
    const link = `/beneficiary_vetting/${vetId}`

    return dispatch(adminNotificationList.saveNewObject({
      user: userId,
      notification_model: notificationModelId,
      message,
      link,
      severity
    })).catch((err) => {
      console.warn(`Failed to create ${notificationType} notification:`, err)
    })
  } catch (err) {
    console.warn('Error creating notification:', err)
  }
}
